import { format } from 'date-fns'
import { ru } from 'date-fns/locale'

const formatDate = (date, formatting) => {
  const changedDate = new Date(date.replace(/-/g, '/')) // для safari, чтобы был правильный формат даты
  return format(changedDate, formatting, { locale: ru })
}

export default formatDate
